<template>
<div class="subscriptionsItem">
  <div class="subscriptionsItem__header">
    <div class="subscriptionsItem__mobileHeader">
      <CurrencyImg
          class="subscriptionsItem__mobileHeader-img"
          :currency="value.currencyId"
      />
      <div class="subscriptionsItem__mobileHeader-desc">
        <span>{{ value.currencyId | getCurrencyTicker }}</span>
        <span class="subscriptionsItem__mobileHeader-status" :style="`color:${statusColor(value.status)};`">{{ statusLabel(value.status) }}</span>
      </div>
    </div>
    <div class="subscriptionsItem__header-item">
      <div class="subscriptionsItem__header-label">{{ $t('subscriptions.email') }}</div>
      <div class="subscriptionsItem__header-value">{{ value.subscriberInfo.email }}</div>
    </div>
    <div class="subscriptionsItem__header-item">
      <div class="subscriptionsItem__header-label">EX ID</div>
      <div class="subscriptionsItem__header-value">{{ value.subscriberInfo.clientId }}</div>
    </div>
    <div class="subscriptionsItem__header-item">
      <div class="subscriptionsItem__header-label">{{ $t('subscriptions.token') }}</div>
      <div class="subscriptionsItem__header-value">
        <CopyString
          :string="value.id"
          :success-message="$t('copy.token_copied')"
          :title="$t('copy.notification')"
          :can-copy="true"
          hash
          />
      </div>
    </div>
    <div class="subscriptionsItem__header-item">
      <div class="subscriptionsItem__header-label">{{ $t('subscriptions.network') }}</div>
      <div class="subscriptionsItem__header-value">{{
          value.networkId | getNetworkName
        }}</div>
    </div>
    <div class="subscriptionsItem__header-item mobileHidden">
      <div class="subscriptionsItem__header-label">{{ $t('subscriptions.currency') }}</div>
      <div class="subscriptionsItem__header-value">
        <CurrencyImg
          :currency="value.currencyId"
          />
        {{ value.currencyId | getCurrencyTicker }}
      </div>
    </div>
    <div class="subscriptionsItem__header-item">
      <div class="subscriptionsItem__header-label">{{ $t('subscriptions.address') }}</div>
      <div class="subscriptionsItem__header-value">
        <CopyString
          :string="value.subscriberInfo.address"
          :success-message="$t('copy.addresses_copied')"
          :title="$t('copy.notification')"
          hash
          can-copy
        />
      </div>
    </div>
    <div class="subscriptionsItem__header-item mobileHidden">
      <div class="subscriptionsItem__header-label">{{ $t('subscriptions.status') }}</div>
      <div class="subscriptionsItem__header-value" :style="`color:${statusColor(value.status)};`">{{ statusLabel(value.status) }}</div>
    </div>
  </div>
</div>
</template>

<script>
import CopyString from "../CopyString";
import {mapState} from "vuex";
import CurrencyImg from "../CurrencyImg";
export default {
    name: "SubscriptionsItem",
    components: {CurrencyImg, CopyString},
    props: {
        value: {
            type: Object,
            default: () => ({}),
        },
    },
    computed: {
        ...mapState('app', ['networks']),
    },
    methods: {
        feeTariffType(status) {
            const feeTariffType = {
                'ORDER_DEPOSIT_FEE': 'referral-commission-type.deposit_by_order_fee',
                'WALLET_WITHDRAWAL_FEE': "referral-commission-type.wallet_withdrawal_fee",
                'PAYOUT_WITHDRAWAL_FEE': "referral-commission-type.payout_withdrawal_fee",
                'WALLET_DEPOSIT_FEE': "referral-commission-type.deposit_by_wallet_fee",
                'PAYOUT_DEPOSIT_FEE': "referral-commission-type.payout_deposit_fee",
                'BRIDGE_EXTERNAL_FEE': 'referral-commission-type.bridge_external_fee',
                'BRIDGE_INTERNAL_FEE': 'referral-commission-type.bridge_internal_fee',
                'EXCHANGE_INTERNAL_FEE': "referral-commission-type.exchange_internal_fee",
                'EXCHANGE_AUTO_FEE': "referral-commission-type.exchange_auto_fee",
            };
            return this.$t(feeTariffType[status]) || '-';
        },
        statusLabel (status) {
            const statuses = {
                'SUCCESS': 'subscriptions.statuses.success',
                'PENDING': 'subscriptions.statuses.pending',
                'BLOCKED': 'subscriptions.statuses.blocked',
                'CANCELED': 'subscriptions.statuses.canceled',
                'DECLINED': 'subscriptions.statuses.declined',
            };
            return this.$t(statuses[status]) || '-';
        },
        statusColor (status) {
            const statuses = {
                'SUCCESS': '#13ce66',
                'PENDING': '#6190e8',
                'BLOCKED': '#EB5757',
                'CANCELED': '#EB5757',
                'DECLINED': '#EB5757',
            };
            return statuses[status] || '-';
        },
    },
};
</script>

<style lang="scss" scoped>
.subscriptionsItem {
  margin-top: 10px;
  background: var(--secondary-color);
  /* Gray 6 */

  font-weight: 500;

  border: 1px solid var(--border-color);
  box-shadow: 0 8px 50px rgba(10, 17, 105, 0.08);
  border-radius: 20px;
  ::v-deep .at-collapse {
    background: var(--secondary-color);
    /* Gray 6 */

    border: 1px solid var(--border-color);
    box-shadow: 0 8px 50px rgba(10, 17, 105, 0.08);
    border-radius: 20px;
  }
  &__mobileHeader {
    display: none;
  }
  &__header {
    display: grid;
    align-items: center;
    grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr 1fr;
    grid-gap: 5px;
    padding: 20px;
    &-label {
      font-size: 14px;
      color: var(--secondary-font-color);
      margin-bottom: 10px;
    }
    &-value {
      display: flex;
      align-items: center;
      font-size: 16px;
      color: var(--primary-font-color);
      > img {
        width: 26px;
        height: 26px;
        margin-right: 5px;
      }
    }
  }
  &__content {

  }
  &__title {
    text-align: left;
    margin-left: 30px;
    font-size: 16px;
    font-weight: 700;
  }
  ::v-deep .at-collapse__icon {
    right: 30px;
    top: 21px;
    font-size: 20px;
    left: unset;
    -webkit-transform: rotate(90deg);
    transform: rotate(90deg);
    width: fit-content;
    height: fit-content;
    @media (max-width: 950px) {
      right: unset;
      top: unset;
      left: 45%;
      bottom: 0;
    }
  }
  ::v-deep .at-collapse__item {
    @media (max-width: 950px) {
      position: relative;
    }
  }
  ::v-deep .at-collapse__item--active > .at-collapse__header .at-collapse__icon {
    -webkit-transform: rotate(270deg);
    transform: rotate(270deg);
  }

  ::v-deep .at-collapse__header {
    background: var(--secondary-color);
    padding: 20px 30px;
    @media (max-width: 950px) {
      padding: 0 10px 15px;
      position: unset;
    }
  }
  ::v-deep .at-collapse__content  {
    padding: 0;
    border-top: 1px solid var(--border-color);
    background: var(--secondary-color);
  }
}
@media screen and (max-width: 768px) {
  .subscriptionsItem {
    &__mobileHeader {
      display: flex;
      align-items: center;
      padding-bottom: 20px;
      border-bottom: 1px solid var(--border-color);
      &-desc {
        font-size: 14px;
        color: var(--primary-font-color);
        display: flex;
        flex-direction: column;
      }
      &-img {
        width: 28px;
        height: 28px;
        margin-right: 10px;
      }
      &-status {
        font-size: 12px;
      }
    }
    &__header {
      padding: 20px 10px;
      grid-template-columns: 1fr;
      &-item {
        display: flex;
        align-items: center;
        justify-content: space-between;
        border-bottom: 1px solid var(--border-color);
        //border-top: 1px solid var(--border-color);
        padding: 17px 0;
        &:last-child {
          border-bottom: none;
        }
      }
    }
  }
  .mobileHidden {
    display: none;
  }
}
.redColor {
  color: #ED6A5E;
}
.greenColor {
  color:#27AE60;
  margin-right: 5px;
}
</style>
